import Storage from 'BUDDI/lib/LocalStorage';
import ApiService from 'BUDDI/lib/ApiService';

BUDDI.lib = {
	Storage,
	apiCall: new ApiService(),
};
